const rowContextKey = Symbol("rowContextKey");

export { rowContextKey };
//# sourceMappingURL=constants.mjs.map
